import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('LastProgress').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    overflow: 'auto',
    width: '90%',
    gap: '12px',
    color: theme.colors.text.primary,
    padding: '20px 0',
    zIndex: '1',
    position: 'relative',
    height: '100%',

    '&[data-variant="secondary"]': {
      '&:after': {
        content: '""',
        width: '50%',
        height: '50%',
        borderRadius: '50%',
        backgroundColor: '#1993DB40',
        position: 'fixed',
        top: '15vh',
        left: '0',
        right: '0',
        margin: 'auto',
        zIndex: '0',
        filter: 'blur(60px)',
        pointerEvents: 'none',
      },
    },

    '&[data-variant="primary"]': {
      '&[data-glowwariant="green"]': {
        '&:after': {
          content: '""',
          width: '100%',
          height: '50%',
          borderRadius: '50%',
          backgroundColor: theme.colors.text.success,
          position: 'fixed',
          top: '10vh',
          left: '0',
          right: '0',
          margin: 'auto',
          zIndex: '0',
          filter: 'blur(160px)',
          pointerEvents: 'none',
        },
      },
    },
  },

  iframe: {
    // display: 'none',
    position: 'absolute',
    width: '100vw',
    height: '100vh',
    zIndex: '0',
    border: 'none',
    // '&[data-showing="false"]': {
    //   display: 'block',
    // },
  },

  header: {
    display: 'flex',
    height: '10vh',
    width: '100%',
    padding: '20px',
    backgroundColor: '#B0B1B81F',
    borderRadius: '12px',
  },

  usernameWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },

  user: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    gap: '16px',
  },

  meetText: {
    fontWeight: '370',
    fontSize: theme.sizes.texts.fontSize.xs,
    lineHeight: theme.sizes.texts.lineHeight.xs,

    color: theme.colors.text.secondary,
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gap: '12px',
    padding: '20px',
    margin: '27px 0',
    position: 'relative',
    zIndex: '1',
  },

  title: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: '470',
    lineHeight: theme.sizes.texts.lineHeight.s,

    textTransform: 'uppercase',
    zIndex: '1',
    color: theme.colors.text.secondary,
  },

  calculating: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',

    fontFamily: 'Inter',
    fontSize: '26px',
    fontWeight: '400',
    lineHeight: '52px',
    fontStyle: 'normal',
    textTransform: 'none',
    zIndex: '1',

    color: theme.colors.text.secondary,

    '&:before': {
      display: 'block',
      top: '-10px',
      content: '""',
      width: '128px',
      height: '128px',
      position: 'absolute',
      background: 'url("/assets/other/loader.png")',
      backgroundSize: 'cover',
      animation: 'loading 1.5s infinite linear',
    },
  },

  '@keyframes loading': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '25%': {
      transform: 'rotate(90deg)',
    },
    '50%': {
      transform: 'rotate(180deg)',
    },
    '75%': {
      transform: 'rotate(270deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },

  spiner: {
    display: 'flex',
    position: 'absolute',
    top: '13vh',
    opacity: '0.3',
  },

  footer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '90%',
    gap: '12px',
    position: 'fixed',
    bottom: '5vh',
    zIndex: '9',
  },

  listTitle: {
    alignSelf: 'flex-start',
    fontFamily: 'Inter',
    fontWeight: '470',
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    textTransform: 'uppercase',
    margin: '0',
    color: theme.colors.text.secondary,
  },

  totalValue: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Space Grotesk',
    fontSize: '48px',
    gap: '12px',
  },

  closeBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-end',
    padding: '10px',
    backgroundColor: '#FFFFFF29',
    borderRadius: '8px',
    aspectRatio: '1/1',
    cursor: 'pointer',
    width: '32px',
    height: '32px',
  },

  balance: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    fontFamily: 'Space Grotesk',
    fontSize: theme.sizes.texts.fontSize.m,
    color: theme.colors.text.primary,

    gap: '4px',
  },

  newBalance: {
    color: theme.colors.text.success,
  },

  sameBalance: {
    color: theme.colors.text.secondary,
  },

  discription: {
    border: '1px solid var(--bg-bg-card, rgba(176, 177, 184, 0.12))',
    borderRadius: '34px',
    padding: '4px 8px',
    fontFamily: 'Inter',
    fontSize: theme.sizes.texts.fontSize.s,
    color: '#757778',
  },

  tokenReward: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '40px',
    backgroundColor: '#B0B1B81F',
    fontFamily: 'Space Grotesk',
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: theme.sizes.texts.lineHeight.xl,

    padding: '4px 8px',
  },

  coinIcon: {
    width: '22px',
    height: '22px',
  },

  shareButton: {
    color: `${theme.colors.text.primary}!important`,
  },
}))
